import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import EditInputField from "./EditInputField";
import SpinnerLoader from "./SpinnerLoader";
import AddContactModal from "./AddContactModal";
import ButtonLoader from "./ButtonLoader";
import { ANALYTICS_SOURCE } from "../constants";
import CommonSurveySelection from "./CommonSurveySelection";
import CustomModal from "./CustomModal";
import ScheduleMeet from "../Pages/ScheduleMeet";
import { DndProvider } from "react-dnd";
import { DraggableAccordion } from "./drag-n-drop/draggableAccordion";
import { HTML5Backend } from "react-dnd-html5-backend";
import { databaseAccordionField } from "./drag-n-drop/accordion-data";
import { UAParser } from "ua-parser-js";
import { syncableContactDB } from "./DatabaseComponent";
import { fetchDataFromIndexedDB, storeDataInIndexedDB } from "../Hooks/IndexedDBUtils";
import { submitMeetingLog } from "../utils/offlineMeeting";
const { REACT_APP_BASE_URL } = process.env;

// Same offline-queue pattern ContactTableDatabase.js already uses for the
// Database page's contact edits - queue into the shared syncableContactDB
// store (synced later via Usersbar's "Synchronize Now") instead of letting
// the PUT fail outright while offline.
const queueContactUpdateOffline = async (data) => {
  const stored = await fetchDataFromIndexedDB(syncableContactDB, "syncableContactsStore");
  const updatedIndexData = { id: data?.id, properties: { ...data } };
  delete updatedIndexData.properties.id;
  await storeDataInIndexedDB(syncableContactDB, "syncableContactsStore", [
    ...(stored || []),
    updatedIndexData,
  ]);
};

const AssociatedContact = ({
  associatedContact,
  showAssociateContact,
  isAssociateListLoading,
  setShowAssociateList,
  dataProperty,
  isModel,
  addContactModalData,
  noAddContact,
  fetchStats,
  hiddenFields = [],
}) => {
  const [userId, setUserId] = useState("");
  const [formState, setFormState] = useState({
    firstname: "",
    middle_initial: "",
    lastname: "",
    email: "",
    canvasser_email: "",
    age: "",
    gender: "",
    marital_status: "",
    interested_in_a_chapter_meeting: false,
    individual_ethnic_categories: "",
    broad_ethnic_groupings: "",
    hispanic_country_origin: "",
    languages: "",
    landline_telephone: "",
    household_primary_language: "",
    cell_phone: "",
    residence_address_line_1: "",
    residence_address__continued_: "",
    residence_city: "",
    residence_state: "",
    residence_zip: "",
    education: "",
    occupation: "",
    occupation_industry: "",
    presence_of_children_code: "",
    residence_household_gender_composition: "",
    opt_in: "",
    political_party: "",
    national_voter_cluster: "",
    national_voter_subcluster: "",
    voter_registration_status: "",
    tracking_attempts: "",
    tracking_rating: "",
    tracking_conversion: "",
    tracking_contacted_voters: "false",
    hs_analytics_source: null,
    hs_analytics_first_touch_converting_campaign: "",
    hs_analytics_last_touch_converting_campaign: "",
    hs_email_sends_since_last_engagement: "",
    hs_email_last_email_name: "",
    hs_email_last_open_date: "",
    lifecyclestage: "",
    tracking_attempts_updated_time: null,
    tracking_conversion_updated_time: null,
    tracking_contacted_voters_updated_time: null,
    tracking_rating_updated_time: null,
    eitc_pre_qualification_status: "",
    do_you_make_less_than__64_000_: "",
    did_you_any_income_earn_income__including_cash__in_2021__2022__2023__: "",
    do_you_have_children_in_the_home_: "",
    have_you_ever_filed_for_earned_income_tax_credits_: "",
    eitc_sms_sequence: "false",
    eitc_email_sequence: "false",
    registration_status: "",
    dwelling_type: "",
    type_of_ballot_used: "",
    prfl_persuadable_voter: "",
    attempt_tracker: null,
  });
  const token = localStorage.getItem("token");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [addContactModal, setAddContactModal] = React.useState(false);
  const [meetingStartDate, setMeetingStartDate] = React.useState(null);
  const [meetingPost, setMeetingPost] = React.useState(null);
  const [meetingLoading, setMeetingLoading] = useState(false);
  const profileEmail = localStorage.getItem("urserMail");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const ownerID = localStorage.getItem("ownerId");
  const [showMeetingLink, setShowMeetingLink] = useState(false);
  const [accordionData, setAccordionData] = useState([]);
  // Property visibility (see docs/implementation-plans/2026-09-15-property-visibility-survey-groups.md)
  // only governs the edit modal - the `hiddenFields` prop comes from the
  // parent's most recent /householdDatabase fetch; this derives which of the
  // currently-open contact's own keys remain visible.
  const [visiblePropertyKeys, setVisiblePropertyKeys] = useState(null);
  const isFieldVisible = (name) => !hiddenFields.includes(name);
  const currentDate = new Date();
  const today = currentDate?.toLocaleDateString("en-GB");
  const deviceLogInfo = UAParser();
  const currentTime = new Date();
  const formattedDate = currentTime.toLocaleString("sv-SE").replace(" ", "T");
  function openModal() {
    setIsOpen(true);
    setMeetingStartDate(formattedDate);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const mapFormFieldsToAccordion = (formFields, accordionTemplate) => {
    const updatedAccordion = accordionTemplate.map((section) => ({
      ...section,
      content: [],
    }));

    formFields.forEach((field) => {
      const targetIndex = updatedAccordion.findIndex(
        (section) => section.id === field.accordion
      );
      if (targetIndex !== -1) {
        updatedAccordion[targetIndex].content.push(field);
      }
    });
    return updatedAccordion;
  };
  const handleSendOnDoorKnock = async () => {
    if (!userId) {
      return;
    }
    const data = {
      id: userId,
      door_knocked_device: JSON.stringify(deviceLogInfo),
      last_door_knocked_by_user: ownerID,
    };
    try {
      if (navigator.onLine === false) {
        await queueContactUpdateOffline(data);
        toast.success("Contact update saved offline!");
        return;
      }
      const res = await axios.put(`${REACT_APP_BASE_URL}/database`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(res.data.message);
    } catch (error) {
      console.error("Error sending door knock update:", error);
    }
  };

  useEffect(() => {
    const visibleFields = visiblePropertyKeys
      ? formFields.filter((field) => visiblePropertyKeys.has(field.name))
      : formFields;
    const normalizedData = mapFormFieldsToAccordion(
      visibleFields,
      databaseAccordionField
    );
    setAccordionData(normalizedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visiblePropertyKeys]);

  const handleInputChange = (e) => {
    if (e?.target?.type === "checkbox") {
      setFormState((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked === true ? "true" : "false",
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
    if (
      e.target.name === "tracking_contacted_voters" &&
      e.target.checked === true
    ) {
      setFormState((prev) => ({
        ...prev,
        tracking_attempts: e.target.checked === true ? "true" : "false",
      }));
    }

    if (e.target.name === "tracking_attempts" && e.target.checked === false) {
      setFormState((prev) => ({
        ...prev,
        tracking_contacted_voters: e.target.checked === true ? "true" : "false",
      }));
    }

    if (e.target.name === "tracking_attempts" && e.target.checked === true) {
      handleSendOnDoorKnock();
    }

    if (
      e.target.name === "tracking_attempts" ||
      e.target.name === "tracking_conversion" ||
      e.target.name === "tracking_contacted_voters" ||
      e.target.name === "tracking_rating"
    ) {
      handleUpdateDate();
    }
  };
  const handleEditDatabaseClick = (user) => {
    openModal();
    setUserId(user?.id);
    const allKeys = Object.keys(user.properties || {});
    setVisiblePropertyKeys(new Set(allKeys.filter((key) => !hiddenFields.includes(key))));
    setFormState((prev) => {
      const updatedState = { ...prev };
      Object.keys(formState).forEach((key) => {
        if (user.properties.hasOwnProperty(key)) {
          updatedState[key] =
            user.properties[key] ||
            (typeof user.properties[key] === "boolean" ? "false" : "");
        }
      });
      return updatedState;
    });
  };

  const handleUpdateDate = () => {
    setFormState((prev) => ({
      ...prev,
      tracking_attempts_updated_time: today,
      tracking_conversion_updated_time: today,
      tracking_contacted_voters_updated_time: today,
      tracking_rating_updated_time: today,
    }));
  };

  const handleDatabaseSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    try {
      const data = {
        id: userId,
        door_knocked_device: JSON.stringify(deviceLogInfo),
        last_door_knocked_by_user: ownerID,
        form_submitted_device: JSON.stringify(deviceLogInfo),
        form_submitted_by_user: ownerID,
        ...formState,
      };

      if (navigator.onLine === false) {
        // This PUT previously had no offline path at all - unlike the
        // Database page's own contact editor (ContactTableDatabase.js), which
        // already queues into the same syncableContactDB store. Editing a
        // household's associated contact while offline just failed silently
        // before this; queue it the same way so it syncs on reconnect.
        await queueContactUpdateOffline(data);
        setShowAssociateList(false);
        toast.success("Contact updated offline successfully!");
        setUserId("");
        closeModal();
        return;
      }

      const res = await axios.put(`${REACT_APP_BASE_URL}/database`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      showAssociateContact();
      setShowAssociateList(false);
      if (res.data) {
        fetchStats();
        toast.success("Contact updated successfully!");
        setUserId("");
        closeModal();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    setUserId("");
  };

  const handleRatingChange = (e) => {
    setFormState((prev) => {
      return {
        ...prev,
        tracking_rating: parseInt(e),
      };
    });
  };

  const handleMeetingLogSubmit = async (e) => {
    e.preventDefault();
    setMeetingLoading(true);
    try {
      if (
        userId &&
        meetingPost?.trim()?.length > 0 &&
        profileEmail &&
        ownerID
      ) {
        const data = {
          contactId: userId,
          startTime: meetingStartDate
            ? new Date(meetingStartDate).toISOString()
            : new Date().toISOString(),
          endTime: formattedDate ? new Date(formattedDate).toISOString() : null,
          outcome: "CANVASSED",
          title:
            "Door Meeting With " +
            formState?.firstname +
            " " +
            formState?.lastname,
          body: meetingPost,
          hubspotOwnerId: ownerID,
          location: "Doorstep",
          attendees: [profileEmail],
        };
        await submitMeetingLog(data, token)
          .then(({ offline, response }) => {
            toast.success(
              offline ? "Meeting saved offline!" : response?.data?.message || "Meeting set!"
            );
            setMeetingStartDate("");
            setMeetingPost("");
          })
          .catch((e) => {
            toast.error(e?.response?.data?.message || "Something went wrong");
          });
      } else {
        toast.error("Fields are missing");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Something went wrong");
      toast.error(e?.message);
    } finally {
      setMeetingLoading(false);
    }
  };

  const formFields = [
    {
      name: "education",
      label: "Education",
      value: formState.education,
      type: "text",
      accordion: 1,
    },
    {
      name: "gender",
      label: "Gender",
      value: formState.gender,
      type: dataProperty?.find((data) => data?.name === "gender")?.fieldType,
      options: dataProperty?.find((data) => data?.name === "gender")?.options,
      accordion: 1,
    },
    {
      name: "occupation",
      label: "Occupation",
      value: formState.occupation,
      type: "text",
      accordion: 1,
    },
    {
      name: "age",
      label: "Age",
      value: formState.age,
      type: "text",
      accordion: 1,
    },
    {
      name: "occupation_industry",
      label: "Occupation Industry",
      value: formState.occupation_industry,
      type: dataProperty?.find((data) => data?.name === "occupation_industry")
        ?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "occupation_industry"
      )?.options,
      accordion: 1,
    },
    {
      name: "marital_status",
      label: "Marital Status",
      value: formState.marital_status,
      type: dataProperty?.find((data) => data?.name === "marital_status")
        ?.fieldType,
      options: dataProperty?.find((data) => data?.name === "marital_status")
        ?.options,
      accordion: 1,
    },
    {
      name: "residence_address_line_1",
      label: "Residence Address Line 1",
      value: formState.residence_address_line_1,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_address__continued_",
      label: "Residence Address Continued",
      value: formState.residence_address__continued_,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_city",
      label: "Residence City",
      value: formState.residence_city,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_state",
      label: "Residence State",
      value: formState.residence_state,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_zip",
      label: "Residence Zip",
      value: formState.residence_zip,
      type: "text",
      accordion: 2,
    },
    {
      name: "landline_telephone",
      label: " Landline Telephone",
      value: formState.landline_telephone,
      type: "text",
      accordion: 2,
    },
    {
      name: "individual_ethnic_categories",
      label: " Individual Ethnic Categories",
      value: formState.individual_ethnic_categories,
      type: dataProperty?.find(
        (data) => data?.name === "individual_ethnic_categories"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "individual_ethnic_categories"
      )?.options,
      accordion: 3,
    },
    {
      name: "broad_ethnic_groupings",
      label: " Broad Ethnic Groupings",
      value: formState.broad_ethnic_groupings,
      type: dataProperty?.find(
        (data) => data?.name === "broad_ethnic_groupings"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "broad_ethnic_groupings"
      )?.options,
      accordion: 3,
    },
    {
      name: "hispanic_country_origin",
      label: " Hispanic Country Origin",
      value: formState.hispanic_country_origin,
      type: "text",
      accordion: 3,
    },
    {
      name: "languages",
      label: "Languages",
      value: formState.languages,
      type: dataProperty?.find((data) => data?.name === "languages")?.fieldType,
      options: dataProperty?.find((data) => data?.name === "languages")
        ?.options,
      accordion: 3,
    },
    {
      name: "household_primary_language",
      label: " Household Primary Language",
      value: formState.individual_ethnic_categories,
      type: dataProperty?.find(
        (data) => data?.name === "household_primary_language"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "household_primary_language"
      )?.options,
      accordion: 3,
    },
    {
      name: "presence_of_children_code",
      label: "Presence of Children Code",
      value: formState.presence_of_children_code,
      type: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.options,
      accordion: 4,
    },
    {
      name: "residence_household_gender_composition",
      label: "Residence Household Gender Composition",
      value: formState.residence_household_gender_composition,
      type: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.options,
      accordion: 4,
    },
    {
      name: "political_party",
      label: "Political Party",
      value: formState.political_party,
      type: dataProperty?.find((data) => data?.name === "political_party")
        ?.fieldType,
      options: dataProperty?.find((data) => data?.name === "political_party")
        ?.options,
      accordion: 4,
    },
    {
      name: "national_voter_cluster",
      label: "National Voter Cluster",
      value: formState.national_voter_cluster,
      type: dataProperty?.find(
        (data) => data?.name === "national_voter_cluster"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "national_voter_cluster"
      )?.options,
      accordion: 4,
    },
    {
      name: "national_voter_subcluster",
      label: "National Voter Subcluster",
      value: formState.national_voter_subcluster,
      type: dataProperty?.find(
        (data) => data?.name === "national_voter_subcluster"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "national_voter_subcluster"
      )?.options,
      accordion: 4,
    },
    {
      name: "registration_status",
      label: "Registration Status",
      value: formState.registration_status,
      type: dataProperty?.find((data) => data?.name === "registration_status")
        ?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "registration_status"
      )?.options,
      accordion: 4,
    },
    {
      name: "prfl_persuadable_voter",
      label: "PRFL PERSUADABLE VOTER",
      value: formState.prfl_persuadable_voter,
      type: "select",
      options: dataProperty?.find(
        (data) => data?.name === "prfl_persuadable_voter"
      )?.options,
      accordion: 4,
    },
    {
      name: "dwelling_type",
      label: "Dwelling Type",
      value: formState.dwelling_type,
      type: "text",
      options: dataProperty?.find((data) => data?.name === "dwelling_type")
        ?.options,
      accordion: 4,
    },
    {
      name: "type_of_ballot_used",
      label: "Type of ballot used",
      value: formState.type_of_ballot_used,
      type: "text",
      options: dataProperty?.find(
        (data) => data?.name === "type_of_ballot_used"
      )?.options,
      disabled: true,
      accordion: 4,
    },
    {
      name: "voter_registration_status",
      label: "Voter Registration Status",
      value: formState.voter_registration_status,
      type: dataProperty?.find(
        (data) => data?.name === "voter_registration_status"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "voter_registration_status"
      )?.options,
      accordion: 4,
    },
    {
      name: "hs_analytics_source",
      label: "Original Source",
      value: formState.hs_analytics_source,
      type: "select",
      options: ANALYTICS_SOURCE,
      accordion: 5,
    },
    {
      name: "hs_analytics_first_touch_converting_campaign",
      label: "First Touch Converting Campaign",
      value: formState.hs_analytics_first_touch_converting_campaign,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_analytics_last_touch_converting_campaign",
      label: "Last Touch Converting Campaign",
      value: formState.hs_analytics_last_touch_converting_campaign,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_sends_since_last_engagement",
      label: "Sends Since Last Engagement",
      value: formState.hs_email_sends_since_last_engagement,
      type: "number",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_last_email_name",
      label: "Last Marketing Email Name",
      value: formState.hs_email_last_email_name,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_last_open_date",
      label: "Last Marketing Email Open Date",
      value: formState.hs_email_last_open_date,
      type: "date",
      disabled: true,
      accordion: 5,
    },
    {
      name: "eitc_pre_qualification_status",
      label: "EITC pre-qualification status",
      value: formState.eitc_pre_qualification_status,
      type: dataProperty?.find(
        (data) => data?.name === "eitc_pre_qualification_status"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "eitc_pre_qualification_status"
      )?.options,
      accordion: 6,
    },
    {
      name: "have_you_ever_filed_for_earned_income_tax_credits_",
      label: "Have you ever filed for Earned Income Tax Credits?",
      value: formState.have_you_ever_filed_for_earned_income_tax_credits_,
      type: dataProperty?.find(
        (data) =>
          data?.name === "have_you_ever_filed_for_earned_income_tax_credits_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) =>
          data?.name === "have_you_ever_filed_for_earned_income_tax_credits_"
      )?.options,
      accordion: 6,
    },
    {
      name: "do_you_make_less_than__64_000_",
      label: "Do you make less than $64,000?",
      value: formState.do_you_make_less_than__64_000_,
      type: dataProperty?.find(
        (data) => data?.name === "do_you_make_less_than__64_000_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "do_you_make_less_than__64_000_"
      )?.options,
      accordion: 6,
    },
    {
      name: "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__",
      label: "Did you any earn income, including cash, in 2021, 2022, or 2023?",
      value:
        formState.did_you_any_income_earn_income__including_cash__in_2021__2022__2023__,
      type: dataProperty?.find(
        (data) =>
          data?.name ===
          "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__"
      )?.fieldType,
      options: dataProperty?.find(
        (data) =>
          data?.name ===
          "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__"
      )?.options,
      accordion: 6,
    },
    {
      name: "do_you_have_children_in_the_home_",
      label: "Do you have children in the home?",
      value: formState.do_you_have_children_in_the_home_,
      type: dataProperty?.find(
        (data) => data?.name === "do_you_have_children_in_the_home_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "do_you_have_children_in_the_home_"
      )?.options,
      accordion: 6,
    },
    {
      name: "eitc_sms_sequence",
      label: "EITC SMS Sequence",
      value: formState.eitc_sms_sequence,
      type: "checkbox",
      accordion: 6,
    },
    {
      name: "eitc_email_sequence",
      label: "EITC Email Sequence",
      value: formState.eitc_email_sequence,
      type: "checkbox",
      accordion: 6,
    },
  ];
  return (
    <>
      <div
        className={`hs-dropdown-menu transition-[opacity,margin] duration  hs-dropdown-open:opacity-100 opacity-0 w-56 hidden  mt-2 min-w-[15rem] bg-gray-100 shadow-md rounded z-[60] ${isModel && "actived"
          }`}
        aria-labelledby="hs-dropdown-hover-event"
      >
        {isAssociateListLoading && (
          <div className="w-full flex items-center justify-center p-4">
            <SpinnerLoader />
          </div>
        )}
        {!isAssociateListLoading &&
          (associatedContact?.length === 0 || !associatedContact) && (
            <div className="w-full flex items-center justify-center p-4 text-canvas-black">
              No Data
            </div>
          )}
        {associatedContact?.length > 0 &&
          associatedContact?.map((e, i) => (
            <button
              key={i}
              type="button"
              onClick={() => {
                handleEditDatabaseClick(e);
              }}
              className="block px-4 py-2 text-sm text-gray-700 font-outfit hover:bg-slate-200 w-full"
            >
              {e.properties.firstname}&nbsp;
              {e.properties.lastname}
            </button>
          ))}
        {!noAddContact && (
          <button
            type="button"
            onClick={() => {
              setAddContactModal(true);
            }}
            className="block px-4 py-2 text-sm font-outfit w-full bg-gray-700 text-white"
          >
            + Add Contact
          </button>
        )}
      </div>
      {addContactModal && (
        <AddContactModal
          isOpen={addContactModal}
          onRequestClose={() => setAddContactModal(false)}
          data={addContactModalData}
        />
      )}
      {userId && (
        <CustomModal
          open={modalIsOpen}
          onClose={closeModal}
          panelclassName="xl:max-w-6xl lg:max-w-5xl md:max-w-3xl max-w-2xl sm:w-full"
        >
          <h2 className="flex justify-center mb-1">Contact Details</h2>

          {formState?.lifecyclestage !== "subscriber" && (
            <div className="flex justify-center align-middle w-full ">
              <h4 className="text-center font-sans mb-1 text-[16px] bg-yellow-100 w-auto py-2 px-3 rounded-lg">
                This Contact Has Heard of The Connecticut Project
              </h4>
            </div>
          )}

          <form onSubmit={handleDatabaseSubmit} noValidate className="mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-3">
              {isFieldVisible("firstname") && (
                <EditInputField
                  label="First Name"
                  name="firstname"
                  value={formState?.firstname}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("lastname") && (
                <EditInputField
                  label="Last Name"
                  name="lastname"
                  value={formState?.lastname}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("cell_phone") && (
                <EditInputField
                  label="Cell Phone"
                  name="cell_phone"
                  value={formState?.cell_phone}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("email") && (
                <EditInputField
                  label="Email"
                  name="email"
                  value={formState?.email}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              <CommonSurveySelection
                contactEmail={formState?.email}
                userId={userId}
              />
              {isFieldVisible("lifecyclestage") && (
                <EditInputField
                  label="Life Cycle Stage"
                  name="lifecyclestage"
                  value={formState?.lifecyclestage}
                  disabled={true}
                  onChange={(e) => handleInputChange(e)}
                  type={
                    dataProperty?.find((data) => data?.name === "lifecyclestage")
                      ?.fieldType
                  }
                  options={
                    dataProperty?.find((data) => data?.name === "lifecyclestage")
                      ?.options
                  }
                />
              )}
              <div className="flex items-end lg:pb-4">
                <button
                  type="button"
                  className="bg-gray-200 py-2 px-6 rounded w-full h-10 font-semibold"
                  onClick={() => setShowMeetingLink(true)}
                >
                  Meeting Link
                </button>
              </div>
              {isFieldVisible("tracking_contacted_voters") && (
                <EditInputField
                  label="Door Answered?"
                  name="tracking_contacted_voters"
                  value={formState?.tracking_contacted_voters}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_conversion") && (
                <EditInputField
                  label=" Interested In 1:1 With An Organizer?"
                  name="tracking_conversion"
                  value={formState?.tracking_conversion}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("interested_in_a_chapter_meeting") && (
                <EditInputField
                  label=" Interested In Attending a Chapter Meeting?"
                  name="interested_in_a_chapter_meeting"
                  value={formState?.interested_in_a_chapter_meeting}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("opt_in") && (
                <EditInputField
                  label=" Cell Phone Opt-in"
                  name="opt_in"
                  value={formState?.opt_in}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_attempts") && (
                <EditInputField
                  label=" Door Knocked?"
                  name="tracking_attempts"
                  value={formState?.tracking_attempts}
                  onChange={handleInputChange}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_rating") && (
                <EditInputField
                  label=" Tracking Rating"
                  name="tracking_rating"
                  value={formState?.tracking_rating}
                  onChange={handleRatingChange}
                  type="rating"
                />
              )}
              {isFieldVisible("attempt_tracker") && (
                <EditInputField
                  label=" Attempt Tracker"
                  name="attempt_tracker"
                  value={formState?.attempt_tracker}
                  // onChange={(e) => handleInputChange(e)}
                  type="text"
                  disabled={true}
                />
              )}
            </div>
            <div className="flex items-center gap-5 mt-6 pb-3">
              <button
                type="submit"
                disabled={isSubmitLoading}
                className="shadow bg-canvas-primary text-white font-bold py-2 px-4 rounded flex items-center gap-3"
              >
                {isSubmitLoading && <ButtonLoader />}
                Confirm Changes
              </button>
              <button
                type="button"
                className="bg-gray-200 py-2 px-6 rounded font-bold"
                onClick={(e) => handleClose(e)}
              >
                Cancel
              </button>
            </div>
            <hr className="border-1 border-gray-400" />
            <div className="pb-3">
              <h2 className="flex justify-center py-1">Interaction Logging</h2>
              <form>
                <EditInputField
                  label="Conversation Notes"
                  name="meetingPost"
                  type="textarea"
                  rows={3}
                  value={meetingPost}
                  onChange={(e) => setMeetingPost(e.target.value)}
                  required={true}
                />
                <div className="flex items-center gap-5">
                  <button
                    type="submit"
                    className="shadow bg-canvas-primary text-white font-bold py-2 px-6 rounded flex items-center justify-center gap-3"
                    disabled={meetingLoading}
                    onClick={meetingPost && handleMeetingLogSubmit}
                  >
                    {meetingLoading && <ButtonLoader />}
                    Log Interaction
                  </button>
                  <button
                    type="button"
                    className="bg-gray-200 py-2 px-6 rounded font-bold"
                    onClick={(e) => handleClose(e)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>

            <DndProvider backend={HTML5Backend}>
              <div className="hs-accordion-group w-full  gap-4">
                <DraggableAccordion
                  accordionData={accordionData}
                  formState={formState}
                  formFields={formFields}
                  setFormState={setFormState}
                  handleInputChange={handleInputChange}
                  dataProperty={dataProperty}
                />
              </div>
            </DndProvider>
          </form>
        </CustomModal>
      )}
      <CustomModal
        open={showMeetingLink}
        onClose={() => setShowMeetingLink(false)}
        panelClass="xl:max-w-6xl lg:max-w-5xl md:max-w-3xl max-w-2xl sm:w-full"
      >
        <ScheduleMeet />
      </CustomModal>
    </>
  );
};

export default AssociatedContact;
